module.exports = __webpack_public_path__ + "static/media/loader2.7962bfcf.svg";